export default "__VITE_ASSET__DDFvDQ81__"